import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';



class App extends Component {
    componentDidMount(){
        const script = document.createElement("script");

        script.src = "/dist/js/custom.js";

        document.body.appendChild(script);
        this.initPage();
    }
  
    initPage(){
    }

    render() {
        return (
        <div className="App">
            <div className="row">
                <div className="col-md-3 col-sm-3 col-xs-12">
                    <div className="info-box box box-default">
                        <span className="info-box-icon bg-white"><i className="fa fa-id-card"></i></span>
                        <div className="info-box-content">
                            <span className="info-box-text">Current Holders</span>
                                <span className="info-box-number">
                                <span className="total_user">XX</span>
                            </span>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-3 col-xs-12">
                    <div className="info-box box box-default">
                        <span className="info-box-icon bg-white"><i className="fa fa-dashboard"></i></span>
                        <div className="info-box-content">
                            <span className="info-box-text">Total Axie</span>
                                <span className="info-box-number">
                                <span className="totale_axi">XX</span>
                            </span>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-3 col-xs-12">
                    <div className="info-box box box-default">
                        <span className="info-box-icon bg-white"><i className="fa fa-leaf"></i></span>
                        <div className="info-box-content">
                            <span className="info-box-text">Total Body Parts Unlock</span>
                            <span className="info-box-number">
                                <span className="total_normal">XX</span>
                                <br></br>
                                <span className="total_mystic">XX</span>
                            </span>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-3 col-xs-12">
                    <div className="info-box box box-default">
                        <span className="info-box-icon bg-white"><i className="fa fa-bar-chart"></i></span>
                        <div className="info-box-content">
                            <span className="info-box-text">Total Market Trade</span>
                            <span className="info-box-number">
                                <span className="total_eth">XX</span>
                                <br></br>
                                <span className="total_count">XX</span>
                            </span>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Sales by ETH Volume</h3>
                            <div  className="form-group tools">
                                <i className="fa fa-exchange" data-id="sales_chart_1"></i>
                                <select id="sales_chart_1_option" className="chart_option form-control">
                                    <option value="359">360 days</option>
                                    <option value="179">180 days</option>
                                    <option value="89">90 days</option>
                                    <option value="59">60 days</option>
                                    <option value="29">30 days</option>
                                    <option value="6">7 days</option>
                                </select>
                            </div>
                        </div>
                        <div className="box-body">
                            <div id="sales_chart_1">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Sales by Order Count</h3>
                            <div  className="form-group tools">
                                <i className="fa fa-exchange" data-id="sales_chart_2"></i>
                                <select id="sales_chart_2_option" className="chart_option form-control">
                                    <option value="359">360 days</option>
                                    <option value="179">180 days</option>
                                    <option value="89">90 days</option>
                                    <option value="59">60 days</option>
                                    <option value="29">30 days</option>
                                    <option value="6">7 days</option>
                                </select>
                            </div>
                        </div>
                        <div className="box-body">
                            <div id="sales_chart_2">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Axie Class Distribution</h3>
                        </div>
                        <div className="box-body">
                            <div id="pie_chart1">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Axie Type Distribution</h3>
                        </div>
                        <div className="box-body">
                            <div id="pie_chart2">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Top Buyers</h3>
                        </div>
                        <div className="box-body">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="index">#</th>
                                        <th>Address</th>
                                        <th>ETH</th>
                                        <th>Count</th>
                                    </tr>
                                </thead>
                                <tbody id="top_buyers">
                                </tbody>
                            </table>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Top Sellers</h3>
                        </div>
                        <div className="box-body">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="index">#</th>
                                        <th>Address</th>
                                        <th>ETH</th>
                                        <th>Count</th>
                                    </tr>
                                </thead>
                                <tbody id="top_sellers">
                                </tbody>
                            </table>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>

                
            </div>
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">New Wallet Count by Date</h3>
                            <div className="form-group tools">
                                <i className="fa fa-exchange" data-id="new_user_chart"></i>
                                <select id="new_user_chart_option" className="chart_option form-control">
                                    <option value="359">360 days</option>
                                    <option value="179">180 days</option>
                                    <option value="89">90 days</option>
                                    <option value="59">60 days</option>
                                    <option value="29">30 days</option>
                                    <option value="6">7 days</option>
                                </select>
                            </div>
                        </div>
                        <div className="box-body">
                            <div id="new_user_chart">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">New Users</h3>
                        </div>
                        <div className="box-body">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th className="index">#</th>
                                        <th>Address</th>
                                        <th>DateTime</th>
                                    </tr>
                                </thead>
                                <tbody id="new_users">
                                </tbody>
                            </table>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">All Time Wallet Count</h3>
                            <div  className="form-group tools">
                                <i className="fa fa-exchange" data-id="new_user_total_chart"></i>
                                <select id="new_user_total_chart_option" className="chart_option form-control">
                                    <option value="359">360 days</option>
                                    <option value="179">180 days</option>
                                    <option value="89">90 days</option>
                                    <option value="59">60 days</option>
                                    <option value="29">30 days</option>
                                    <option value="6">7 days</option>
                                </select>

                            </div>
                        </div>
                        <div className="box-body">
                            <div id="new_user_total_chart">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12">
                    <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Mystic Axie Price History</h3>
                            <div  className="form-group tools">
                                <i className="fa fa-exchange" data-id="mystic_history_chart"></i>
                                <select id="mystic_history_chart_option" className="chart_option form-control">
                                    <option value="10">Last 10</option>
                                    <option value="30">Last 30</option>
                                    <option value="60">Last 60</option>
                                    <option value="100">Last 100</option>
                                    <option value="1000">Last 1k</option>
                                    <option value="10000">Last 10k</option>
                                </select>
                                <select id="mystic_history_chart_option2" className="chart_option form-control">
                                    <option value="all">All</option>
                                    <option value="1">Single</option>
                                    <option value="2">Double</option>
                                    <option value="3">Triple</option>
                                    <option value="4">Quad</option>
                                    <option value="5">Quintuple</option>
                                    <option value="6">Sextuple</option>
                                </select>
                            </div>
                        </div>
                        <div className="box-body">
                            <div id="mystic_history_chart">
                            </div>
                        </div>
                        <div className="overlay box_loading">
                            <i className="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js